import Notification from '@/models/Notifications/Notification'
import Vue from 'vue'
import {Module} from 'vuex'
import {NotificationsState, RootState} from '@/types/store/states'
import {RawNotification} from '@/types/entity/RawNotification'

const store: Module<NotificationsState, RootState> = {
  namespaced: true,
  state: {
    notifications: {},
    panelExpanded: false,
    unreadCount: 0
  },
  getters: {
    getNotification: state => (data: RawNotification) => {
      if (state.notifications[data._id]) {
        state.notifications[data._id].setData(data)
      } else {
        Vue.set(state.notifications, data._id, new Notification(data))
      }
      return state.notifications[data._id]
    },
    getNotifications: (state, getters) => (list: RawNotification[]) => {
      let notifications = []
      for (let notificationData of list) {
        notifications.push(getters.getNotification(notificationData))
      }
      return notifications
    }
  },
  mutations: {
    unreadCount (state, unreadCount) {
      state.unreadCount = unreadCount
    },
    readOne (state) {
      state.unreadCount--
    },
    toggleExpanded (state, expanded) {
      state.panelExpanded = expanded !== undefined ? expanded : !state.panelExpanded
    },
    deleteNotification (state, notificationId) {
      Vue.delete(state.notifications, notificationId)
    },
    notifications (state, notifications) {
      state.notifications = notifications
    },
    appendNotifications (state, notifications) {
      state.notifications = Object.assign(state.notifications, notifications)
    }
  },
  actions: {
    /**
     * Load notifications
     *
     * @param context
     * @param append
     * @param offset
     * @returns {Promise<void>}
     */
    async loadNotifications (context, {append = false}) {
    },
    /**
     * Mark notification as read
     *
     * @param context
     * @param notificationId
     * @returns {Promise<boolean>}
     */
    async markRead (context, notificationId) {

    },
    /**
     * Delete notification by id
     *
     * @param context
     * @param notificationId
     * @returns {Promise<boolean>}
     */
    async deleteNotification (context, notificationId) {

    },
    /**
     * Delete notifications by params
     *
     * @param context
     * @param notificationId
     * @returns {Promise<boolean>}
     */
    async deleteNotifications (context, {day}) {

    }
  }
}
export default store